import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { UserActions } from "./UserActions";
import type { Profile } from "./types";

interface UserTableProps {
  users: Profile[] | undefined;
  onStatusChange: (userId: string, action: 'activate' | 'suspend') => Promise<void>;
  onEdit: (user: Profile) => void;
  onRoleChange: (user: Profile) => void;
}

export const UserTable = ({
  users,
  onStatusChange,
  onEdit,
  onRoleChange,
}: UserTableProps) => {
  return (
    <div className="rounded-md border shadow-sm bg-white">
      <Table>
        <TableHeader>
          <TableRow className="bg-muted/50">
            <TableHead className="w-[250px]">Name</TableHead>
            <TableHead className="hidden md:table-cell">Contact</TableHead>
            <TableHead className="hidden md:table-cell">Role</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users?.map((user) => (
            <TableRow key={user.id} className="hover:bg-muted/50">
              <TableCell className="font-medium">
                <div>
                  {user.first_name} {user.last_name}
                  <div className="text-sm text-muted-foreground md:hidden">
                    {user.role || 'User'}
                  </div>
                </div>
              </TableCell>
              <TableCell className="hidden md:table-cell">{user.phone_number}</TableCell>
              <TableCell className="hidden md:table-cell">{user.role || 'User'}</TableCell>
              <TableCell>
                <Badge variant={user.status === 'suspended' ? "destructive" : "default"}>
                  {user.status === 'suspended' ? 'Suspended' : 'Active'}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <UserActions
                  userId={user.id}
                  status={user.status || 'active'}
                  role={user.role || 'user'}
                  onStatusChange={onStatusChange}
                  onEdit={() => onEdit(user)}
                  onRoleChange={() => onRoleChange(user)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};